<script>
    import {fade} from 'svelte/transition';
    export let title = "";
    export let content = "";
    export let legend = false;
    export let contentImage = false;
    export let contentImageSource = "";
    let isHovered = false;

    function mouseOver(){
        isHovered = true;
    }
    
    function mouseLeave(){
        isHovered = false;
    }
</script>
<style>
    .tool{
        margin-left: 10px;
        background: white;
        position: absolute;
        padding: 10px;
        border-radius: 0.25em;
        z-index: 3;
        box-shadow: 0 2px 4px 2px #00aec92a;
    }

    div{
        display:inline;
    }

    .title{
        color: #858796;
        font-weight: bold !important;
        font-size: 1em;
    }

    p{
        margin-bottom: 0.5rem;
        font-size: 0.8em;      
    }
    
    p strong{
        color: #6e6f7c;
        font-weight: 600; 
    }
</style>

<div on:mouseover={() => mouseOver()} on:mouseleave={() => mouseLeave()}>
    <slot />
</div>

{#if isHovered}    
    {#if legend}
        <div class="tool font-weight-light" transition:fade={{duration: 200}}>
            {#if title != ""}<h5 class="title">{title}</h5>{/if}
            <hr class="solid">
            {#each content as item}
                <p><strong class="text-{item.color}">{item.name}<i class="{item.iconType} fa-{item.icon}"></i></strong> {item.value}</p>
            {/each}
        </div>
    {:else}
        <div class="tool font-weight-light">
            {#if title != ""}
                <p class="title">{title}</p>
                <hr class="solid">
            {/if}
            <p>{content}</p>
            {#if contentImage}
                <img src={contentImageSource} alt="">
            {/if}
        </div>
    {/if}   
{/if}

